import React, {Component} from 'react';
import axios from 'axios';

const PROD_SLACK_WEBHOOK_URI = 'https://hooks.slack.com/services/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';
const PROD_SLACK_CHANNEL_NAME = '#monitor_app_errors';
const DEV_SLACK_WEBHOOK_URI = 'https://hooks.slack.com/services/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';
const DEV_SLACK_CHANNEL_NAME = '#bot_development';

function slackErrorsChannelWebhook() {
    return global.__ENV__ == 'production' ? PROD_SLACK_WEBHOOK_URI : DEV_SLACK_WEBHOOK_URI
}
function slackErrorsChannelName() {
    return global.__ENV__ == 'production' ? PROD_SLACK_CHANNEL_NAME : DEV_SLACK_CHANNEL_NAME
}

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {

        const data = {
            channel: slackErrorsChannelName(),
            username: 'Worthy APP',
            text: `${error.stack}\nComponentStack: ${info.componentStack}\n Error:${error}`
        };

        axios.post(slackErrorsChannelWebhook(), JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });

        alert('Oops!!! Something went wrong.');

        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return this.props.template || (<h1>Oops!!! Something went wrong</h1>);
        } else {
            return this.props.children;
        }
    }
}
